







import Vue from 'vue';
import { mapState, mapActions } from 'vuex';
import RadioToggleButtons from '@/components/common/form/RadioToggleButtons.vue';
export default Vue.extend({
    name: 'LanguageSwitcher',
    components: { RadioToggleButtons },
    computed: {
        ...mapState(['locale', 'langs']),
        availableLanguages() {
            return this.langs.map((lang: string) => ({ value: lang, label: this.$t(lang) }));
        },
        val() {
            return { value: this.locale, label: this.$t(this.locale) };
        },
    },
    methods: {
        ...mapActions(['changeLocale']),
    },
});
